import { ShopsAvailable } from '@availability/const';
import { encodeUid } from '@shared/helpers';
import { StateUtils } from '@spartacus/core';
import { SHOPS_AVAILABLE } from '../availability-state';

export const LOAD_SHOPS_AVAILABLE = '[CustomCatalog] Shops available load';
export const LOAD_SHOPS_AVAILABLE_SUCCESS = '[CustomCatalog] Shops available load success';
export const LOAD_SHOPS_AVAILABLE_FAIL = '[CustomCatalog] Shops available load fail';
export const RESET_SHOPS_AVAILABLE = '[CustomCatalog] reset shops available';

export class LoadShopsAvailable extends StateUtils.EntityLoadAction {
  readonly type = LOAD_SHOPS_AVAILABLE;

  constructor(
    public productCode: string,
    public unitCode: string,
  ) {
    super(SHOPS_AVAILABLE, encodeUid(productCode, unitCode));
  }
}

export class LoadShopsAvailableFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_SHOPS_AVAILABLE_FAIL;

  constructor(
    public productCode: string,
    public unitCode: string,
    payload: any,
  ) {
    super(SHOPS_AVAILABLE, encodeUid(productCode, unitCode), payload);
  }
}

export class LoadShopsAvailableSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_SHOPS_AVAILABLE_SUCCESS;

  constructor(
    public productCode: string,
    public unitCode: string,
    public payload: ShopsAvailable,
  ) {
    super(SHOPS_AVAILABLE, encodeUid(productCode, unitCode), payload);
  }
}

export class ResetShopsAvailable extends StateUtils.EntityRemoveAllAction {
  readonly type = RESET_SHOPS_AVAILABLE;

  constructor() {
    super(SHOPS_AVAILABLE);
  }
}

export type ShopsAvailableAction =
  | LoadShopsAvailable
  | LoadShopsAvailableFail
  | LoadShopsAvailableSuccess
  | ResetShopsAvailable;
